import type { Provider } from '../types';

export function buildGrantUrl(path: string, provider: Provider) {
  const url = new URL(path, window.location.origin);

  url.searchParams.append('provider_name', provider.nylasName);

  for (const scope of provider.scopes) {
    url.searchParams.append('scopes[]', scope);
  }

  return url;
}
